"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiverClient = void 0;
var util_1 = require("../../../util");
var receiver_interface_1 = require("./receiver.interface");
var room_error_code_1 = require("../../../websocket-channel/room-error-code");
var CONNECT_TIMEOUT_TIME = 12 * 1000;
/**
 * chunk 模式下行client
 * 改这里的代码要慎重，改动需要多验证结束请求与发起下一条请求的逻辑是否正确
 * 一定要验证数据准确性
 */
var ReceiverClient = /** @class */ (function () {
    function ReceiverClient(dependency) {
        this.dependency = dependency;
        this.position = 0;
        this.onceOpen = false;
    }
    ReceiverClient.prototype.establishConnection = function (requestUrl) {
        var _this = this;
        try {
            !this.onceOpen && this.checkConnectTimeoutTimer();
            this.xmlHttpRequest = new XMLHttpRequest();
            this.position = 0;
            this.xmlHttpRequest.onreadystatechange = function () {
                if (_this.xmlHttpRequest.readyState === XMLHttpRequest.LOADING) {
                    _this.clearConnectTimoutTimer(true);
                    _this.chunkParse(_this.xmlHttpRequest.responseText);
                }
                else if (_this.xmlHttpRequest.readyState === XMLHttpRequest.DONE) {
                    _this.clearConnectTimoutTimer(true);
                    _this.closeConnection();
                }
            };
            this.xmlHttpRequest.open('get', requestUrl);
            this.xmlHttpRequest.setRequestHeader('content-type', 'application/json');
            this.xmlHttpRequest.send();
            this.xmlHttpRequest.onerror = function () {
                util_1.ConnectionLog.info('bind/get onerror');
                _this.dependency.receive();
            };
        }
        catch (error) {
            util_1.ConnectionLog.error("ReceiverClient XMLHttpRequest Error, error.message:" + (error === null || error === void 0 ? void 0 : error.message) + ",error.stack:" + (error === null || error === void 0 ? void 0 : error.stack));
            this.dependency.receive();
        }
    };
    ReceiverClient.prototype.abortConnection = function () {
        var _a;
        (_a = this.xmlHttpRequest) === null || _a === void 0 ? void 0 : _a.abort();
    };
    ReceiverClient.prototype.chunkParse = function (chunkData) {
        var startIndex = this.position;
        var finishIndex = chunkData.indexOf(receiver_interface_1.DELIMITER, startIndex);
        while (finishIndex > -1) {
            var subChunk = chunkData.substring(startIndex, finishIndex);
            if (subChunk) {
                this.dependency.handleResponse(subChunk);
                if (subChunk.indexOf('connection closed') > -1) {
                    this.position = 0;
                    return;
                }
            }
            startIndex = finishIndex + receiver_interface_1.DELIMITER.length;
            finishIndex = chunkData.indexOf(receiver_interface_1.DELIMITER, startIndex);
        }
        this.position = startIndex;
    };
    ReceiverClient.prototype.closeConnection = function () {
        if (this.xmlHttpRequest.status === XMLHttpRequest.UNSENT) {
            return;
        }
        if (this.xmlHttpRequest.status < 200 || this.xmlHttpRequest.status >= 400) {
            util_1.ConnectionLog.info("closeConnection: " + this.xmlHttpRequest);
            this.dependency.receive();
        }
        else {
            // 请求结束消息会走这条分支
            this.chunkParse(this.xmlHttpRequest.responseText);
        }
    };
    ReceiverClient.prototype.checkConnectTimeoutTimer = function () {
        var _this = this;
        // 先清除前一个 timer
        this.clearConnectTimoutTimer(false);
        this.connectTimeoutTimer = setTimeout(function () {
            util_1.ConnectionLog.error('bind/get 12s 仍未收到回包');
            _this.dependency.disconnect({
                errCode: room_error_code_1.RoomErrorCode.BIG_COLLAB_CONNECT_TIMEOUT,
                shutDown: true,
            });
        }, CONNECT_TIMEOUT_TIME);
    };
    ReceiverClient.prototype.clearConnectTimoutTimer = function (isOpen) {
        if (isOpen && !this.onceOpen) {
            this.onceOpen = true;
        }
        if (this.connectTimeoutTimer) {
            window.clearTimeout(this.connectTimeoutTimer);
            this.connectTimeoutTimer = undefined;
        }
    };
    return ReceiverClient;
}());
exports.ReceiverClient = ReceiverClient;
